import { HTTP } from '../../utils'
import { getItem } from '../../storage'

export const getStreamDetail = (uuid) => {
  return getItem('token').then(token => {
    return HTTP(token).get('entity/' + uuid)
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const getAlumniStreamRecommendations = (recommendationData) => {
  if (!recommendationData) {
    return
  }
  let url = '/recommendation/alumniStreams'
  return getItem('token').then(token => {
    return HTTP(token).post(url, recommendationData)
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const getAdvisorStreamRecommendations = (recommendationData) => {
  if (!recommendationData) {
    return
  }
  let url = '/recommendation/advisorStreams'
  return getItem('token').then(token => {
    return HTTP(token).post(url, recommendationData)
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}



// WEBPACK FOOTER //
// ./src/app/stream/api.js